import Splide from '@splidejs/splide';

const EL = '.js-gallery';
const ACTIVE_CLASS = 'is-active';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    perPage: 3,
    perMove: 1,
    gap: 60,
    pagination: false,
    breakpoints: {
      1365: {
        gap: 30,
      },
      768: {
        gap: 20,
        perPage: 2
      }
    }
  }).mount();
}
